import z from "zod";
import { BaseFirestoreSchema } from "./firestore.schema";

// Schemas

export const AIMinutesTemplateSchema = BaseFirestoreSchema.extend({
  name: z.string(),
  data: z.string(), // json
});

// DTOs

export const CreateAIMinutesTemplateDtoSchema =
  AIMinutesTemplateSchema.partial();

export const PutAIMinutesTemplateDtoSchema = CreateAIMinutesTemplateDtoSchema;

export const PatchAIMinutesTemplateDtoSchema = CreateAIMinutesTemplateDtoSchema;
